import { FormControl, Validators } from '@angular/forms';

export class FormatValidators extends Validators {
  public static prefixedWith = (prefix: string) => (control: FormControl) =>
    control.value && control.value.toString().substring(0, prefix.length) === prefix
      ? null
      : { prefixedWith: { expected: prefix } };
}
